import { useApi, useDocument } from '@longnan/ui';
import type { CompanyDoc, EcosystemDoc, GroupOverview, ImageryDoc, ImageryItem, NewsDoc } from './types';

export interface SiteData {
  company: CompanyDoc;
  eco: EcosystemDoc;
  news: NewsDoc;
  imagery: ImageryDoc;
  overview: GroupOverview;
}

/** 集团门户所有数据的汇总读取。全部就绪才返回 data，否则由调用方显示加载或错误态。 */
export function useSiteData(): { loading: boolean; error: string | null; data: SiteData | null } {
  const company = useDocument<CompanyDoc>('group', 'company.json');
  const eco = useDocument<EcosystemDoc>('group', 'ecosystem.json');
  const news = useDocument<NewsDoc>('group', 'news.json');
  const imagery = useDocument<ImageryDoc>('group', 'imagery.json');
  const overview = useApi<GroupOverview>('/api/group/overview');

  const all = [company, eco, news, imagery, overview];
  const loading = all.some((s) => s.loading);
  const error = all.find((s) => s.error)?.error ?? null;
  const ready = !loading && !error && company.data && eco.data && news.data && imagery.data && overview.data;

  return {
    loading,
    error,
    data: ready
      ? {
          company: company.data!,
          eco: eco.data!,
          news: news.data!,
          imagery: imagery.data!,
          overview: overview.data!,
        }
      : null,
  };
}

export function findImage(imagery: ImageryDoc, id: string): ImageryItem {
  const item = imagery.items.find((i) => i.id === id);
  if (!item) throw new Error(`图片清单缺少 ${id}`);
  return item;
}

/** 署名行：作者 · 授权（来源 Wikimedia Commons）。 */
export function creditOf(item: ImageryItem): string | undefined {
  if (!item.credit) return undefined;
  return `${item.credit.artist} · ${item.credit.license} · Wikimedia Commons`;
}
